import { CommonModule } from '@angular/common';
import { LocaleDatePipe } from './core/pipes/locale-date.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './core/modules/material.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export const SHARED_MODULES = [
	CommonModule,
	FormsModule,
	MaterialModule,
	ReactiveFormsModule,
	RouterModule,
	TranslateModule,
	LocaleDatePipe,
];